import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/library',
  component: Layout,
  name: 'Library',
  meta: {
    title: '资料库',
    icon: 'i-ant-design:folder-open-outlined',
    auth: [],
  },
  children: [
    {
      path: 'mcp',
      name: 'LibraryMcpInterfaceIndex',
      component: () => import('@/views/mcp/index.vue'),
      meta: {
        title: 'MCP列表',
        icon: 'i-ant-design:api-outlined',
        auth: [],
      },
    },
    {
      path: 'memo',
      name: 'LibraryMemo',
      component: () => import('@/views/organization/memo/index.vue'),
      meta: {
        title: '备忘录',
        icon: 'i-ant-design:profile-outlined',
        auth: 'memo:list',
      },
    },
    {
      path: 'ui-components',
      name: 'LibraryUiComponents',
      component: () => import('@/views/library/ui-components/index.vue'),
      meta: {
        title: 'UI组件库',
        icon: 'i-ant-design:appstore-outlined',
        auth: [],
      },
    },
    {
      path: '/mcp/index',
      name: 'McpInterfaceIndex',
      redirect: '/library/mcp',
      meta: {
        title: 'MCP列表',
        auth: [],
        menu: false,
        activeMenu: '/library/mcp',
      },
    },
    {
      path: '/organization/memo',
      name: 'OrganizationMemo',
      redirect: '/library/memo',
      meta: {
        title: '备忘录',
        auth: 'memo:list',
        menu: false,
        activeMenu: '/library/memo',
      },
    },
  ],
}

export default routes